import { __assign, __extends, __read, __rest } from "tslib";
import React, { useEffect, useState } from "react";
import classNames from "classnames";
import EventEmitter from "eventemitter3";
import { View, Button, Text } from "../_core/components";
import { Popup } from "../popup";
import { callBoth } from "../_util/call-both";
import { noop } from "../_util/noop";
import { useTranslation } from "../config-provider/i18n";
import { useConfig } from "../_util/use-config";
export function ActionSheet(_a) {
    var visible = _a.visible, _b = _a.onVisibleChange, onVisibleChange = _b === void 0 ? noop : _b, _c = _a.onSelect, onSelect = _c === void 0 ? noop : _c, _d = _a.onClose, onClose = _d === void 0 ? noop : _d, title = _a.title, _e = _a.options, options = _e === void 0 ? [] : _e, className = _a.className;
    var t = useTranslation();
    var classPrefix = useConfig().classPrefix;
    return (React.createElement(Popup, { visible: visible, onVisibleChange: onVisibleChange, onClose: onClose, overlay: React.createElement(View, { className: classNames(classPrefix + "-actionsheet", className) },
            title && (React.createElement(View, { className: classPrefix + "-actionsheet__title" }, title)),
            React.createElement(View, { className: classPrefix + "-actionsheet__actions" }, options.map(function (option, index) {
                var _a = typeof option === "string" ? { name: option } : option, name = _a.name, description = _a.description, destructive = _a.destructive, disabled = _a.disabled, openType = _a.openType, className = _a.className, style = _a.style;
                return (React.createElement(Button, { key: index, className: classNames(classPrefix + "-actionsheet__item", className, {
                        "is-disabled": disabled,
                        "is-destructive": destructive,
                    }), hoverClass: classPrefix + "-actionsheet__item--hover", style: style, disabled: disabled, openType: openType, onClick: function () {
                        onSelect(index);
                        onClose();
                        onVisibleChange(false);
                    } },
                    React.createElement(Text, { className: classPrefix + "-actionsheet__name" }, name),
                    description && (React.createElement(Text, { className: classPrefix + "-actionsheet__description" }, description))));
            })),
            React.createElement(View, { className: classPrefix + "-actionsheet__cancel" },
                React.createElement(Button, { className: classPrefix + "-actionsheet__cancel-button", hoverClass: classPrefix + "-actionsheet__cancel-button--hover", onClick: function () {
                        onClose();
                        onVisibleChange(false);
                    } }, t.cancelText))) }));
}
var ActionSheetEmitter = /** @class */ (function (_super) {
    __extends(ActionSheetEmitter, _super);
    function ActionSheetEmitter() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return ActionSheetEmitter;
}(EventEmitter));
export var actionSheetEmitter = new ActionSheetEmitter();
export function ActionSheetManager(props) {
    var _a = __read(useState(props), 2), options = _a[0], setOptions = _a[1];
    useEffect(function () {
        var onShow = function (_a) {
            var options = __rest(_a, []);
            setOptions(__assign(__assign({}, options), { visible: true }));
        };
        var onHide = function () {
            setOptions(function (options) { return (__assign(__assign({}, options), { visible: false })); });
        };
        actionSheetEmitter.on("show", onShow);
        actionSheetEmitter.on("hide", onHide);
        return function () {
            actionSheetEmitter.removeListener("show", onShow);
            actionSheetEmitter.removeListener("hide", onHide);
        };
    }, []);
    return (React.createElement(ActionSheet, __assign({}, options, { onClose: callBoth(options.onClose, function () { return actionSheetEmitter.emit("hide"); }) })));
}
ActionSheet.show = function show(options) {
    actionSheetEmitter.emit("show", options);
};
//# sourceMappingURL=ActionSheet.js.map